import { Box, MenuItem, Select, Typography, Button } from '@mui/material';
import * as React from 'react';
import { useAppSelector } from '../../../../app/hooks';
import { League, Player, Team } from '../../../../sdk/model';
import { toSalary } from '../../../util/SalaryDisplay';
import TeamRoster from '../../team/roster/TeamRosterSmall';
import { findDefaultTeam } from '../service';
import { getRemainingRosterSpots } from '../../../util/TeamUtils';
import { MINIMUM_ONE_YEAR_SALARY } from '../../../util/ContractUtils';

interface teamViewerProps {
  league: League,
  teams: Array<Team> | undefined,
  currentSeasonYear: number | undefined,
  salaryCap: number | undefined,
  userId: string | undefined,
  playerMap: Map<string | undefined, Player | undefined>,
  teamMap: Map<string | undefined, Team>,
  rosterSettings: Map<string | undefined, number | undefined>,
  tradeDisabled: boolean
}

function DraftTeamViewer(props: teamViewerProps) {

  const [visibleTeamId, setVisibleTeamId] = React.useState<string | undefined>(findDefaultTeam(props.teams!, props.userId!) || props.teams![0].id);
  
  const user = useAppSelector((state) => state.user);

  if(props.teams === undefined) {
    return <div>Team Data Loading...</div>
  }


  const visibleTeam: Team | undefined = visibleTeamId ? props.teamMap.get(visibleTeamId) : undefined;
  console.log("Visible Team (" , visibleTeamId , "): ", visibleTeam);

  const myTeam = visibleTeam?.owners?.some(owner => owner.id === user.id);
  console.log("Team Map: ", props.teamMap);
  
  const remainingRosterSpots = visibleTeam ? getRemainingRosterSpots(visibleTeam, props.league) : 0;
  const currentSalary = visibleTeam?.currentSeasonSalary ? visibleTeam.currentSeasonSalary - remainingRosterSpots * MINIMUM_ONE_YEAR_SALARY : 0;

  return <Box sx={{ height: '50%' }}>
    <Select name="viewingTeam" label="Team" labelId="viewingTeamLabel" value={visibleTeamId} onChange={(event) => setVisibleTeamId(event.target.value)}
      sx={{ flexGrow: 1 }}>
      {Object.entries(props.teams!).map(([teamIndex, team]) => 
        <MenuItem key={team.id} value={team.id}>{team.name}</MenuItem>
      )}
    </Select>
    {!myTeam && !props.tradeDisabled && <Button color="primary" variant="contained" onClick={() => window.open('/league/' + props.league.id + '/trade?teamId=' + visibleTeam?.id, '_blank', 'noreferrer')}>Propose Trade</Button>}
    <Typography variant="h5" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>
      {visibleTeam?.name}
    </Typography>
    <Typography variant="h6" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>
      ({toSalary(props.salaryCap! - currentSalary)} cap space remaining in {props.currentSeasonYear})
    </Typography>
    <TeamRoster leagueId={props.league.id} roster={visibleTeam?.playerRoster} currentSeasonYear={props.currentSeasonYear!}
      playerMap={props.playerMap} rosterSettings={props.rosterSettings} />
  </Box>
}

export default DraftTeamViewer;